/*
|--------------------------------------------------------------------------
| Site Forms: Newsletter Modal Form
|--------------------------------------------------------------------------
*/

/**
 * Site Cookie
 * @namespace
 */
__gh__webApp.siteCookie = {
	
	
	/**
	 * Default cookie object
	 */
	"defaultCookie": {
		"newsletter":{
			"modalForm": {
				"callback"	: "__gh__webApp.siteCookie.callbacks.newsletter.modalForm",
				"createdAt"	: new Date(),
				"expires"	:1,
				"value"		: {
					"pageViews":1
				}
			}
		}/*,
		"engagement":{
			"pages": {
				"createdAt"	: new Date(),
				"expires"	: 1,
				"value"		: {
					"items": []
				}
				
			}
		}*/
	},
	
	
	/**
	 * Initialize
	 */
	"init": function(){
		this.cleanCookie();	
	},
	
	/**
	 * Cleans the siteCookie and runs any callbacks
	 * https://jsfiddle.net/qpp7xzax/1/
	 */
	"cleanCookie": function(){

		var siteCookie 	= this.getCookie(),
			siteCookie 	= (!siteCookie) ? this.defaultCookie : siteCookie,
			commonJS	= __gh__webApp.common;
		
		function isExpiredCheck(createdAt,expireDays){
			var today 		= new Date();
				createdAt	= new Date(createdAt);
				expireDate 	= createdAt.setMilliseconds(createdAt.getMilliseconds() + expireDays * 864e+5);
			return (today >= expireDate);
		}
		
		
		/**
		 * Processes an object with an expiration date
		 */
		function process(property,value) {
			var expires 	= value.expires,
				createdAt	= value.createdAt,
				parent		= value.parent,
				isExpired	= isExpiredCheck(createdAt,expires),
				callback	= ("callback" in value) ? value.callback : null;

		    if (isExpired){
        		siteCookie[parent][property] = defaultSiteCookie[parent][property];
		    }
		    
		    if (callback) {
			   	siteCookie = commonJS.callFunction({
				    "callback":callback,
				    "data": {
					    "siteCookie":siteCookie,
					    "cookie": value,
					    "cookieName": property
				    }
				});
		    }
		    
		}
		
		
		/**
		 *  Traverse 
		 *  Loop over site cookie nodes and find objects with an expiration setting, pass object to process function
		 *  http://stackoverflow.com/questions/722668/traverse-all-the-nodes-of-a-json-object-tree-with-javascript
		 */
		function traverse(object,callback,parent) {
		    for (var property in object) {
		       	var isObject 	= commonJS.isObject(object[property]),
		       		isArray 	= commonJS.isArray(object[property]);
		        
		        if (object[property] === null || !isObject || isArray) { continue; }
						
		        if (isObject && "expires" in object[property]) {
            		object[property].parent = parent;
		        	callback.apply(this,[property,object[property]]);
		        }
		        else {
		          //going on step down in the object tree!!
		          traverse(object[property],callback,property);
		        }
		    }
		}


		traverse(siteCookie,process,null);

		this.saveCookie(siteCookie);
		
	},
	
	
	/**
	 * Get Site Cookie
	 */
	"getCookie": function(){
		var commonJS	= __gh__webApp.common;
			siteCookie 	= commonJS.getCookie("__gh__xNjVTDfSrzUHkuidwqGUgRaxH");
			//siteCookie 	= (siteCookie) ? commonJS.decrypt(siteCookie,"p8zZQLhtzJiQ") : null;
			siteCookie	= (siteCookie) ? JSON.parse(siteCookie) : null;
		
		if (siteCookie){
			return siteCookie;
		}
		
		return null;
	},
	
	
	/**
	 * Saves the site cookie
	 * @param {object} siteCookie - site cookie object
	 */
	"saveCookie": function(siteCookie) {
		var commonJS 	= __gh__webApp.common,
			domain		= __gh__coreData.siteData.baseURL.replace("http://","");
			siteCookie	= JSON.stringify(siteCookie);
			//siteCookie  = commonJS.encrypt(siteCookie,"p8zZQLhtzJiQ");
			
		commonJS.setCookie({
			"name"		: "__gh__xNjVTDfSrzUHkuidwqGUgRaxH", 
			"value"		: siteCookie,
			"domain"	: domain,
			"expires"	: 365
		});
	},
	
	
	/**
	 * Save default cookie
	 */
	"saveDefaultCookie": function(){
		var thisObject		  = __gh__webApp.siteCookie,
			defaultSiteCookie = thisObject.defaultCookie;
		thisObject.saveCookie(defaultSiteCookie);
	},
	
	
	/**
	 * Get cookie value
	 * @param {string} path - path to the value you want in dot notation
	 * @example 
	 * __gh__webApp.siteCookie.getValue("newsletter.modalForm.expires");
	 */
	"getValue": function(path){
		var thisObject = __gh__webApp.siteCookie,
			commonJS   = __gh__webApp.common,
			siteCookie = thisObject.getCookie();
		
		return commonJS.getObjectProperty(path);		
	},
	
	
	/**
	 * Callbacks
	 */
	"callbacks":{
		
		
		"newsletter":{
			
			/**
			 * Modal form callback
			 * @param {object} data
			 * @param {object} data.siteCookie - current siteCookie object
			 * @param {object} data.cookie - cookie object stored for this callback
			 * @param {string} data.cookieName - name of this node in the siteCookie object
			 */
			"modalForm": function(data){

				var newsletterModalForm  = __gh__webApp.siteForms.newsletterModalForm,
					siteCookie 	= data.siteCookie,
					cookie		= data.cookie,
					cookieName	= data.cookieName,
					pageViews	= cookie.value.pageViews;
				
				if (pageViews == 2){
					newsletterModalForm.showFormWithDelay();
				}
				
				pageViews++;

				siteCookie[cookie.parent][cookieName].value.pageViews = pageViews;

				return siteCookie;
			}
		}
	}
};
